type TFlatType = 'Black'|'Exclusivo'|'Plus'|'Requinte'|'Completo'|'Ideal'|'Sem Plano';
type TTypeHighlight = 'PREMIUM'|'NOVOS'|'DESTAQUES';

interface IHotelHighlights {
    codContrato: number;
    destaque: TTypeHighlight;
    tipoDestaque: number;
    slug: string;
    nome: string;
    descricao: string;
    indicadoPara: Array<any>;
    pais: string;
    internacional: boolean;
    codCidade: number;
    cidade: string;
    uf: string;
    bairro: string;
    endereco: string;
    numero: string;
    cep: string;
    latitude: number;
    longitude: number;
    tipoPlano: TFlatType;
    codTipoPlano: string;
    valoresDiariaMontreal: Array<any>;
    valorDiariaHotel: any;
    tipoHotel: string;
    tipoQuarto: Array<any>;
    tipoApartamento: string;
    redeHotel: string;
    regimeAlimentacao: Array<any>;
    comodidades: Array<any>;
    informativo: Array<any>;
    fotos: Array<string>;
    hoteisProximos: Array<any>;
    planosPeriodoDuplo: any;
    planosPeriodoTriplo: any;
}
interface IHotelHighlightsConstructor {
    codContrato: number;
    destaque: TTypeHighlight;
    nome: string;
    descricao: string;
    pais: string;
    cidade: string;
    uf: string;
    bairro: string;
    endereco: string;
    numero: string;
    cep: string;
    tipoPlano: TFlatType;
    fotos: Array<string>;
}
class HotelHighlights {
    codContrato: number;
    destaque: TTypeHighlight;
    tipoDestaque: number;
    slug: string;
    nome: string;
    descricao: string;
    indicadoPara: Array<any>;
    pais: string;
    internacional: boolean;
    codCidade: number;
    cidade: string;
    uf: string;
    bairro: string;
    endereco: string;
    numero: string;
    cep: string;
    latitude: number;
    longitude: number;
    tipoPlano: TFlatType;
    codTipoPlano: string;
    valoresDiariaMontreal: Array<any>;
    valorDiariaHotel: any;
    tipoHotel: string;
    tipoQuarto: Array<any>;
    tipoApartamento: string;
    redeHotel: string;
    regimeAlimentacao: Array<any>;
    comodidades: Array<any>;
    informativo: Array<any>;
    fotos: Array<string>;
    hoteisProximos: Array<any>;
    planosPeriodoDuplo: any;
    planosPeriodoTriplo: any;

    constructor(hotelHighlights: IHotelHighlightsConstructor) {
        const {
            codContrato,
            destaque,
            nome,
            descricao,
            pais,
            cidade,
            uf,
            bairro,
            endereco,
            numero,
            cep,
            tipoPlano,
            fotos,
        } = hotelHighlights;
        this.codContrato = codContrato;
        this.destaque = destaque;
        this.tipoDestaque = this.getHighlightTtype(destaque);
        this.slug = this.getSlug(nome);
        this.nome = nome;
        this.descricao = descricao;
        this.indicadoPara = [];
        this.pais = pais;
        this.internacional = this.isInternational(pais);
        this.codCidade = 0;
        this.cidade = cidade;
        this.uf = uf;
        this.bairro = bairro;
        this.endereco = endereco;
        this.numero = numero;
        this.cep = cep;
        this.latitude = 0;
        this.longitude = 0;
        this.tipoPlano = tipoPlano;
        this.codTipoPlano = '';
        this.valoresDiariaMontreal = [];
        this.valorDiariaHotel = null;
        this.tipoHotel = 'Resort';
        this.tipoQuarto = [];
        this.tipoApartamento = '';
        this.redeHotel = '';
        this.regimeAlimentacao = [];
        this.comodidades = [];
        this.informativo = [];
        this.fotos = fotos;
        this.hoteisProximos = [];
        this.planosPeriodoDuplo = null;
        this.planosPeriodoTriplo = null;
    }
    public getHighlightTtype(destaque: 'PREMIUM' | 'NOVOS' | 'DESTAQUES'): number {
        let tipoDestaque = 0;
        switch (destaque) {
            case 'PREMIUM':
                tipoDestaque = 39;
                break;
            case 'NOVOS':
                tipoDestaque = 0;
                break;
            case 'DESTAQUES':
                tipoDestaque = 36;
                break;
        }
        return tipoDestaque;
    }
    public getSlug(name: string): string {
        return name
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-');
    }
    public isInternational(country: string): boolean {
        return  country !== 'Brasil';
    }
}
const PREMIUM_HOTELS: Array<IHotelHighlights> = [
    new HotelHighlights({
            codContrato: 1010,
            destaque: 'PREMIUM',
            nome: 'Nannai Resort & Spa - Porto de Galinhas – PE',
            descricao: `Simples e mágico, em uma atmosfera sofisticada. Para entender o Nannai Resort & Spa, você precisa
             desconstruir o conceito tradicional de hospedagem. Muito além de um destino, um lugar e uma viagem,
             o estabelecimento é um estado de espírito. Por lá, cada momento de sua jornada importa tanto quanto o destino.
             O Nannai fica localizado em uma reserva de Mata Atlântica, entre coqueiros e manguezais, com toda a riqueza
             deste ecossistema. O mar, à frente, é protegido por arrecifes, formando uma piscina natural de águas mornas e
             cristalinas. Por isso, muitos hóspedes costumam dizer que o Nannai é um mundo à parte.`,
            pais: 'Brasil',
            cidade: 'Porto de Galinhas',
            uf: 'PE',
            bairro: '',
            endereco: 'Estrada Municipal Linha Ávila',
            numero: '801',
            cep: '55590000',
            tipoPlano: 'Black',
            fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/12img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/13img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/14img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PE/PORTO_DE_GALINHAS/HOTEL/NANNAI/15img.jpeg',
        ]
    }),
    new HotelHighlights({
            codContrato: 1011,
            destaque: 'PREMIUM',
            nome: 'Grand Hyatt Rio de Janeiro – RJ',
            descricao: `Localizado em uma área com cenário exuberante, a poucos passos da praia da Barra, imerso na natureza
             nativa da Reserva, com fácil acesso às praias de Grumari e Prainha, e a poucos minutos dos principais shoppings
             da nobre região da Barra da Tijuca. O Grand Hyatt também se destaca pela arquitetura contemporânea e design
             sustentável mesclam o conforto e os serviços de luxo com a informalidade de um resort na praia e o oferecimento
             de diversas atividades de lazer.`,
            pais: 'Brasil',
            cidade: 'Rio de Janeiro',
            uf: 'RJ',
            bairro: 'Barra da Tijuca',
            endereco: 'Av. Lúcio Costa',
            numero: '9600',
            cep: '22795007',
            tipoPlano: 'Exclusivo',
            fotos: [
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/1img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/2img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/3img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/4img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/5img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/6img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/7img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/8img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/9img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/10img.jpeg',
                'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RJ/RIO_DE_JANEIRO/HOTEL/GRAND_HYATT/11img.jpeg',
            ]
    }),
    new HotelHighlights({
        codContrato: 1012,
        destaque: 'PREMIUM',
        nome: 'Fera Palace Hotel - Salvador - BA',
        descricao: `Situado no Centro Histórico de Salvador, na rua Chile – a primeira rua do Brasil –, o Fera Palace
         Hotel leva seus hóspedes a uma viagem no tempo através da arquitetura e design marcantes, inspirados
         nos anos 30, década de sua construção. Na cobertura do primeiro hotel de luxo de Salvador, encontra-se uma
         piscina maravilhosa de 25m de comprimento, com borda infinita e vista deslumbrante sobre a Baía de Todos-os-Santos.`,
        pais: 'Brasil',
        cidade: 'Salvador',
        uf: 'BA',
        bairro: '',
        endereco: 'R. Chile - Centro Histórico',
        numero: '20',
        cep: '40020000',
        tipoPlano: 'Plus',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/SALVADOR/HOTEL/FERA_PALACE/7img.jpeg'
        ],
    })
];
const NEW_HOTELS: Array<IHotelHighlights> = [
    new HotelHighlights({
        codContrato: 2020,
        destaque: 'NOVOS',
        nome: 'Casa La Torre Hotel Boutique - Trancoso – BA',
        descricao: `Casa La Torre é um charmoso Hotel Boutique, situado no Quadrado de Trancoso/BA, com uma belíssima
         vista para o mar, piscina integrada a natureza e delicada decoração. É o equilíbrio perfeito entre o que há
         de mais encantador na natureza e mais sofisticado.`,
        pais: 'Brasil',
        cidade: 'Porto Seguro',
        uf: 'BA',
        bairro: 'Trancoso',
        endereco: 'Quadrado de Trancoso - Praça São João Batista',
        numero: '',
        cep: '45810000',
        tipoPlano: 'Plus',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/BA/TRANCOSO/HOTEL/CASA_LA_TORRE/12img.jpeg',
        ],
    }),
    new HotelHighlights({
        codContrato: 2021,
        destaque: 'NOVOS',
        nome: 'Vidam Hotel Aracaju – SE',
        descricao: `O Vidam Hotel Aracaju oferece a capital sergipana e região uma excelente oportunidade para hospedagem,
         com altíssimo padrão de qualidade e opções de conforto e de serviço compatíveis com os melhores hotéis de luxo
         de nível internacional\n\n.Os serviços do Vidam Hotel Aracaju prezam pela cortesia e pela hospitalidade típicas
         das regiões mais acolhedoras do Nordeste do país. Passeios exclusivos, city tour com ônibus panorâmicos e eventos
         planejados inteiramente para garantir o entretenimento de qualidade dos seus hóspedes também fazem parte da agenda.`,
        pais: 'Brasil',
        cidade: 'Aracaju',
        uf: 'SE',
        bairro: 'Atalaia',
        endereco: 'R. Dr. Bezerra de Menezes',
        numero: '40',
        cep: '49035240',
        tipoPlano: 'Requinte',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/12img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SE/ARACAJU/HOTEL/VIDAM/13img.jpeg',
        ],
    }),
    new HotelHighlights({
        codContrato: 2022,
        destaque: 'NOVOS',
        nome: 'Villa Praia - Jericoacoara – CE',
        descricao: `Situada próximo a um dos principais cartões postais de Jericoacoara, a Duna Por do Sol, e a 250m da
        Praia Principal, a Villa Praia é uma das 7 pousadas do Grupo La Villa e uma excelente opção para admirar a
        exuberante natureza de Jeri. Além de uma incrível vista, com piscina e bar, é ideal para assistir ao lindo Pôr
        do sol de Jericoacoara. A Pousada conta com 14 acomodações totalmente equipadas, além de todos os serviços
        exclusivos do Grupo La Villa. O luxo está na atenção especial prestada pela equipe a cada hóspede, permitindo
        um atendimento personalizado. A Villa Praia irá superar todas as suas expectativas.`,
        pais: 'Brasil',
        cidade: 'Jijoca de Jericoacoara',
        uf: 'CE',
        bairro: 'Jijoca',
        endereco: 'R. Nova Jeri',
        numero: '',
        cep: '62598000',
        tipoPlano: 'Plus',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/12img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/13img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/14img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/JIJOCA_DE_JERICOACOARA/HOTEL/VILLA_PRAIA/15img.jpeg',
        ],
    }),
];
const HIGHLIGHTED_HOTELS: Array<IHotelHighlights> = [
    new HotelHighlights({
        codContrato: 3030,
        destaque: 'DESTAQUES',
        nome: 'Pousada Alto da Boa Vista - Campos do Jordão – SP',
        descricao: `A Pousada Alto da Boa Vista, em Campos do Jordão, contempla chalés que trazem consigo um clássico
         requinte e a sensação de estar em outro país. Ela está inserida num cenário de rara beleza natural,
         é ideal para casais que buscam vivenciar momentos inesquecíveis. No seu entorno, os canyons cercados por
         montanhas e muito verde permitem o contato com a natureza de forma diferenciada e propõem um ar de romantismo
          sem fim.`,
        pais: 'Brasil',
        cidade: 'Campos do Jordão',
        uf: 'SP',
        bairro: 'Alto Boa Vista',
        endereco: 'R. das Hortências',
        numero: '605',
        cep: '12460000',
        tipoPlano: 'Requinte',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/SP/CAMPOS_DO_JORDAO/POUSADA/ALTO_BOA_VISTA/12img.jpeg',
        ],
    }),
    new HotelHighlights({
        codContrato: 3031,
        destaque: 'DESTAQUES',
        nome: 'Ba\'ra Hotel - João Pessoa – PB',
        descricao: `Arte, gastronomia, conforto, arquitetura e serviços primorosos esperam por você no Ba'ra Hotel.
        Além disso, ele já foi premiado como o quinto melhor hotel do mundo na categoria novos e badalados pela TripAdvidor,
        Travellers Choice Awards 2023, realizado anualmente pela plataforma, que celebra as propriedades que receberam
        avaliações excelentes.`,
        pais: 'Brasil',
        cidade: 'João Pessoa',
        uf: 'PB',
        bairro: 'Cabo Branco',
        endereco: 'Av. Cabo Branco',
        numero: '1148',
        cep: '58045010',
        tipoPlano: 'Requinte',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/1img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/2img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/3img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/4img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/5img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/6img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/7img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/8img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/9img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/10img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/11img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/12img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/13img.jpeg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/PB/JOAO_PESSOA/HOTEL/BARA/14img.jpeg',
        ],
    }),
];

export const HOTEIS_DESTAQUES = [
    ...PREMIUM_HOTELS,
    ...NEW_HOTELS,
    ...HIGHLIGHTED_HOTELS,
];

export const HOTEL_HIGHLIGHTS = [
    new HotelHighlights({
        codContrato: 1001,
        destaque: 'DESTAQUES',
        nome: 'Hotel Casa da Montanha',
        descricao: `
            O hotel Casa da Montanha é um dos mais tradicionais hotéis de Gramado. Desde 1997, todos os cômodos contam
            uma parte da história do estabelecimento, com muito afeto para que você viva uma experiência única na Serra.
            Localizado em uma cidade conhecida por suas raízes coloniais e baixas temperaturas, o Casa da Montanha é o
            hotel perfeito para receber você e sua família em qualquer época do ano.
        `,
        pais: 'Brasil',
        cidade: 'Gramado',
        uf: 'RS',
        bairro: 'Centro',
        endereco: 'Avenida Borges de Medeiros',
        numero: '3166',
        cep: '95670000',
        tipoPlano: 'Requinte',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CASA_MONTANHA/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CASA_MONTANHA/5img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CASA_MONTANHA/6img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CASA_MONTANHA/7img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CASA_MONTANHA/8img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 1002,
        destaque: 'DESTAQUES',
        nome: 'Hotel Parador',
        descricao: `
            O Hotel Parador está localizado em Cambará do Sul, uma cidade tranquila em uma das regiões mais frias do Brasil.
            Os cômodos são inspirados nos lodges africanos, valorizando e respeitando a paisagem incrível que é cenário
            da sua estada. Acampar em meio à natureza, mas com tudo o que você merece. Esse é o conceito de glamping.
            A palavra, que vem da união de glamour e camping, significa aquele lugar que oferece experiências de acampamento
            com todo o conforto e charme de um hotel de luxo.`,
        pais: 'Brasil',
        cidade: 'Cambará Do Sul',
        uf: 'RS',
        bairro: 'Morro Agudo',
        endereco: 'Estrada do Faxinal - RS',
        numero: '427',
        cep: '95480000',
        tipoPlano: 'Plus',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/3img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/5img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/6img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/7img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/CAMBARA_DO_SUL/HOTEL/PARADOR/8img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 2001,
        destaque: 'NOVOS',
        nome: 'Best Western Premier Maceió',
        descricao: `
            Conheça o Best Western Premier Maceió, localizado na Praia de Pajuçara em Maceió, Alagoas. Desfrute de uma
            linda vista para o oceano nas suítes vista mar ou desde a piscina no andar da cobertura.
            Os apartamentos variam de 32m2 na categoria Standard até 120m2 na Suíte Presidencial Suite que inclui uma
            espaçosa sacada com banheira de hidromassagem para 2 pessoas apreciarem a bela vista de frente para o mar.`,
        pais: 'Brasil',
        cidade: 'Maceió',
        uf: 'AL',
        bairro: 'Pajuçara',
        endereco: 'Av. Dr. Antônio Gouveia',
        numero: '925',
        cep: '57030170',
        tipoPlano: 'Exclusivo',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MACEIO/HOTEL/BEST_WESTERN_PREMIER/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MACEIO/HOTEL/BEST_WESTERN_PREMIER/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MACEIO/HOTEL/BEST_WESTERN_PREMIER/5img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MACEIO/HOTEL/BEST_WESTERN_PREMIER/6img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 2002,
        destaque: 'NOVOS',
        nome: 'Pousada Vila Suíça',
        descricao: `
            Localizada em Monte Verde, a 500 metros da Praça da Árvore e 800 metros do Celeiro Shopping Monte Verde,
            a Pousada Vila Suíça oferece acomodações completa. Todos os quartos dispõem de mesa de trabalho, TV de tela
            plana, banheiro privativo, roupa de cama e toalhas. Para completar, a Pousada Vila Suíça serve um delicioso
            café da manhã continental aos hóspedes.`,
        pais: 'Brasil',
        cidade: 'Monte Verde',
        uf: 'MG',
        bairro: '',
        endereco: 'Rua Araucária',
        numero: '59',
        cep: '37653000',
        tipoPlano: 'Ideal',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/MG/MONTE_VERDE/POUSADA/VILLA_SUICA/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/MG/MONTE_VERDE/POUSADA/VILLA_SUICA/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/MG/MONTE_VERDE/POUSADA/VILLA_SUICA/4img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/MG/MONTE_VERDE/POUSADA/VILLA_SUICA/5img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 2003,
        destaque: 'NOVOS',
        nome: 'Hotel Laghetto Villa Moura',
        descricao: `
            O Hotel Laghetto Villa Moura está situado em Rio Grande. Entre as comodidades da propriedade estão um
            restaurante, recepção 24 horas e serviço de quarto, além de Wi-Fi gratuito em toda a propriedade.
            Para sua comodidade, o estacionamento privativo está disponível no local.`,
        pais: 'Brasil',
        cidade: 'Porto Alegre',
        uf: 'RS',
        bairro: '',
        endereco: 'General Neto',
        numero: '333',
        cep: '96200010',
        tipoPlano: 'Completo',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/PORTO_ALEGRE/HOTEL/LAGHETTO_VILLA_MOURA/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/PORTO_ALEGRE/HOTEL/LAGHETTO_VILLA_MOURA/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/PORTO_ALEGRE/HOTEL/LAGHETTO_VILLA_MOURA/3img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/PORTO_ALEGRE/HOTEL/LAGHETTO_VILLA_MOURA/4img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/PORTO_ALEGRE/HOTEL/LAGHETTO_VILLA_MOURA/5img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 3001,
        destaque: 'PREMIUM',
        nome: 'Árvo Boutique Hotel',
        descricao: `
            O Árvo Boutique Hotel é uma experiência intimista, leve, reservada e acolhedora, a beira mar da deslumbrante
            praia de Peroba, na cidade de Maragogi, Alagoas. Um lugar com diferencial em sua estadia renovadora, criando
            laços com a natureza e memórias inesquecíveis de sua estadia em Maragogi.
            A estrutura do hotel é formada por piscina, restaurante, bar, serviço de praia, serviço de quarto, caiaques
            e SUP para uso exclusivo dos hóspedes, além de estacionamento sem custo adicional.
            A estrutura do hotel fornece também, lounge a beira mar, piscina e experiência de Spas com borda infinita
            para o mar, trazendo o máximo de conforto para o hóspede.`,
        pais: 'Brasil',
        cidade: 'Maragogi',
        uf: 'AL',
        bairro: '',
        endereco: 'Rod AL 101 norte',
        numero: '1016',
        cep: '57955000',
        tipoPlano: 'Sem Plano',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/3img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/4img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/5img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/AL/MARAGOGI/HOTEL/ARVO_BOUTIQUE/8img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 3002,
        destaque: 'PREMIUM',
        nome: 'Cityhome BAV Residenz',
        descricao: `
            O condomínio Bav Residenz está localizado no melhor bairro da cidade. Um residencial charmoso e aconchegante
            para você vivenciar uma experiência incrível na cidade mais romântica do Brasil! Não quer ter trabalho durante
            sua estada? O Bav Residenz tem parceria com o famoso Sport Hotel Bavária, localizado do outro lado da rua,
            onde você tem acesso a estrutura do hotel, pagando uma taxa especial, ou até mesmo tomar café da manhã ou
            realizar suas refeições no restaurante do empreendimento.`,
        pais: 'Brasil',
        cidade: 'Gramado',
        uf: 'RS',
        bairro: '',
        endereco: 'Rua Ermelinda Barbacovi',
        numero: '66',
        cep: '95670000',
        tipoPlano: 'Exclusivo',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CITYHOME_BAV_RESIDENZ/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CITYHOME_BAV_RESIDENZ/4img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/RS/GRAMADO/HOTEL/CITYHOME_BAV_RESIDENZ/5img.jpg',
        ]
    }),
    new HotelHighlights({
        codContrato: 3003,
        destaque: 'PREMIUM',
        nome: 'Hotel Varandas Beach',
        descricao: `
            Mais do que um hotel pé na areia, o Hotel Varandas Beach é um local acolhedor em meio a tranquilidade da praia
            de Águas Belas, Ceará. Aqui, você e sua família desfrutam de acomodações aconchegantes que valorizam elementos
            rústicos da cultura e artesanato local, com toques de requinte. Se encante com as paisagens naturais da região,
            se conecte com a natureza e viva momentos únicos na companhia de quem você mais ama, aqui no Varandas.`,
        pais: 'Brasil',
        cidade: 'Cascavel',
        uf: 'CE',
        bairro: 'Águas Belas',
        endereco: 'Rua Boa Viagem',
        numero: 'S/N',
        cep: '62850000',
        tipoPlano: 'Requinte',
        fotos: [
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/1img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/2img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/3img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/4img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/5img.jpg',
            'https://www.viagensmontreal.com/design/HOTEIS_DESTAQUES_SITE/CE/CASCAVEL/HOTEL/VARANDAS_BEACH/6img.jpg',
        ]
    }),
];

